import React, { forwardRef } from "react";
import FontAwesome from "react-fontawesome";
import { NESTED_PADDING, ROOT_PARENT } from "../utilities/dragUtils";
import { RowGripIcon } from "./RowGripIcon";

/** @typedef {import("../types").InfoNode} InfoNode */

/**
 * Overlay shown while dragging a node.
 * @param {{ node: InfoNode, projectedDepth?: number, childCount?: number }} props
 * @returns {JSX.Element | null}
 */
export const NodeDragOverlay = forwardRef(function NodeDragOverlay(
	{ node, projectedDepth, childCount = 0 },
	ref,
) {
	if (!node) return null;
	const depth =
		typeof projectedDepth === "number"
			? projectedDepth
			: node.type === "folder" ||
					!node.parentId ||
					node.parentId === ROOT_PARENT
				? 0
				: 1;
	const indentOffset = depth * NESTED_PADDING;
	const nodeIconName = node.type === "folder" ? "folder" : "file-text-o";
	const isNested = depth > 0;
	const translation = depth > 0 ? `translateX(-${NESTED_PADDING}px)` : null;
	const transformValue =
		[translation, "scale(0.94)"].filter(Boolean).join(" ") || undefined;
	return (
		<div
			ref={ref}
			className="infopage__row infopage__row--overlay"
			data-node-type={node.type}
			data-node-parent={isNested ? "folder" : ROOT_PARENT}
			data-node-overlay
			style={{
				marginLeft: indentOffset,
				transform: transformValue,
				cursor: "grabbing",
			}}
		>
			<div className="row__drag-handle">
				<RowGripIcon />
			</div>
			<div className="row__content">
				<FontAwesome name={nodeIconName} className="row__type-icon" />
				<p className="row__title">{node.title}</p>
				{node.type === "folder" && childCount > 0 ? (
					<span className="row__meta">
						{childCount} page{childCount === 1 ? "" : "s"}
					</span>
				) : null}
			</div>
		</div>
	);
});
